/**
 * 工具函数封装
 */
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime' // ES 2015

dayjs.extend(relativeTime)

export function formateDate(date, rule = 's') {
    if (rule === 's') return dayjs.unix(date).format('YYYY/MM/DD HH:mm:ss')
    return dayjs(date).format('YYYY/MM/DD HH:mm:ss')
}

export function checkEmail(value) {
    const reg =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (reg.test(value)) {
        return true
    } else {
        return false
    }
}

export function isChinese(value) {
    const reg = /^[\u4e00-\u9fa5]+$/
    const str = value.replace(/\s*/g, '')
    if (reg.test(str)) {
        return true
    } else {
        return false
    }
}

export function isEnglish(value) {
    const reg = /^[A-Za-z]+$/
    const str = value.replace(/\s*/g, '')
    if (reg.test(str)) {
        return true
    } else {
        return false
    }
}

export function isNumber(value) {
    const reg = /^[0-9]+$/
    const str = value.replace(/\s*/g, '')
    if (reg.test(str)) {
        return true
    } else {
        return false
    }
}

export function isEngAndNum(value) {
    const reg = /(?=.*[a-zA-Z]).{8,30}/

    if (reg.test(value)) {
        return true
    } else {
        return false
    }
}

export function initOldParams(oldParams) {
    return JSON.parse(JSON.stringify(oldParams))
}

export function contrastParams(oldParams, newParams) {
    if (JSON.parse(JSON.stringify(oldParams) === '{}')) return

    const isChangeParamsKey = []
    for (let key in oldParams) {
        if (Array.isArray(newParams[key]) && Array.isArray(oldParams[key])) {
            let isChange = oldParams[key].every(item => {
                return (!newParams[key].includes(item) ||
                    newParams[key].length !== oldParams[key].length
                )
            })
            isChange && isChangeParamsKey.push(key)
        } else {
            if (oldParams[key] != newParams[key]) isChangeParamsKey.push(key)
        }
    }
    return isChangeParamsKey
}

/* 公用 loading svg */
export function loadingSvg(color = '#165DFF') {
    return `
     <path d="M876.864 782.592c3.264 0 6.272-3.2 6.272-6.656 0-3.456-3.008-6.592-6.272-6.592-3.264 0-6.272 3.2-6.272 6.592 0 3.456 3.008 6.656 6.272 6.656z m-140.544 153.344c2.304 2.432 5.568 3.84 8.768 3.84a12.16 12.16 0 0 0 8.832-3.84 13.76 13.76 0 0 0 0-18.56 12.224 12.224 0 0 0-8.832-3.84 12.16 12.16 0 0 0-8.768 3.84 13.696 13.696 0 0 0 0 18.56zM552.32 1018.24c3.456 3.648 8.32 5.76 13.184 5.76a18.368 18.368 0 0 0 13.184-5.76 20.608 20.608 0 0 0 0-27.968 18.368 18.368 0 0 0-13.184-5.824 18.368 18.368 0 0 0-13.184 5.76 20.608 20.608 0 0 0 0 28.032z m-198.336-5.76c4.608 4.8 11.072 7.68 17.6 7.68a24.448 24.448 0 0 0 17.536-7.68 27.456 27.456 0 0 0 0-37.248 24.448 24.448 0 0 0-17.536-7.68 24.448 24.448 0 0 0-17.6 7.68 27.52 27.52 0 0 0 0 37.184z m-175.68-91.84c5.76 6.08 13.824 9.6 21.952 9.6a30.592 30.592 0 0 0 22.016-9.6 34.368 34.368 0 0 0 0-46.592 30.592 30.592 0 0 0-22.016-9.6 30.592 30.592 0 0 0-21.952 9.6 34.368 34.368 0 0 0 0 46.592z m-121.152-159.36c6.912 7.36 16.64 11.648 26.368 11.648a36.736 36.736 0 0 0 26.432-11.584 41.28 41.28 0 0 0 0-55.936 36.736 36.736 0 0 0-26.432-11.584 36.8 36.8 0 0 0-26.368 11.52 41.28 41.28 0 0 0 0 56zM12.736 564.672a42.88 42.88 0 0 0 30.784 13.44 42.88 42.88 0 0 0 30.784-13.44 48.128 48.128 0 0 0 0-65.216 42.88 42.88 0 0 0-30.72-13.44 42.88 42.88 0 0 0-30.848 13.44 48.128 48.128 0 0 0 0 65.216z m39.808-195.392a48.96 48.96 0 0 0 35.2 15.36 48.96 48.96 0 0 0 35.2-15.36 54.976 54.976 0 0 0 0-74.56 48.96 48.96 0 0 0-35.2-15.424 48.96 48.96 0 0 0-35.2 15.424 54.976 54.976 0 0 0 0 74.56zM168.32 212.48c10.368 11.008 24.96 17.408 39.68 17.408 14.592 0 29.184-6.4 39.552-17.408a61.888 61.888 0 0 0 0-83.84 55.104 55.104 0 0 0-39.616-17.408c-14.656 0-29.248 6.4-39.616 17.408a61.888 61.888 0 0 0 0 83.84zM337.344 124.8c11.52 12.16 27.712 19.264 43.968 19.264 16.256 0 32.448-7.04 43.968-19.264a68.672 68.672 0 0 0 0-93.184 61.248 61.248 0 0 0-43.968-19.264 61.248 61.248 0 0 0-43.968 19.264 68.736 68.736 0 0 0 0 93.184z m189.632-1.088c12.672 13.44 30.528 21.248 48.448 21.248s35.712-7.808 48.384-21.248a75.584 75.584 0 0 0 0-102.464A67.392 67.392 0 0 0 575.36 0c-17.92 0-35.776 7.808-48.448 21.248a75.584 75.584 0 0 0 0 102.464z m173.824 86.592c13.824 14.592 33.28 23.104 52.736 23.104 19.584 0 39.04-8.512 52.8-23.104a82.432 82.432 0 0 0 0-111.744 73.472 73.472 0 0 0-52.8-23.168c-19.52 0-38.912 8.512-52.736 23.168a82.432 82.432 0 0 0 0 111.744z m124.032 158.528c14.976 15.872 36.032 25.088 57.216 25.088 21.12 0 42.24-9.216 57.152-25.088a89.344 89.344 0 0 0 0-121.088 79.616 79.616 0 0 0-57.152-25.088c-21.184 0-42.24 9.216-57.216 25.088a89.344 89.344 0 0 0 0 121.088z m50.432 204.032c16.128 17.088 38.784 27.008 61.632 27.008 22.784 0 45.44-9.92 61.568-27.008a96.256 96.256 0 0 0 0-130.432 85.76 85.76 0 0 0-61.568-27.072c-22.848 0-45.44 9.984-61.632 27.072a96.192 96.192 0 0 0 0 130.432z" fill="${color}" p-id="2340"></path>
    `
}

/* 公用生成占位符 
 @params:
 newObj: 新返回的对象
 oldObj: 原始对象
 placeholderKeys:需要做占位处理的key
 callback: 有特殊情况可使用回调
*/

export function handleMergData(newObj = {}, oldObj, placeholderKeys, callback) {
    for (const key in oldObj) {
        if (placeholderKeys.includes(key) && !oldObj[key]) {
            newObj[key] = '--'
        } else {
            newObj[key] = oldObj[key]
        }
    }
    callback && callback()

    return newObj
}

/* 防抖 */
export function debounce(fn, delay, immediate = false) {
    let timer = null
    let isInvoke = false

    const _debounce = function(...args) {
        return new Promise((resolve, reject) => {
            try {
                if (timer) clearTimeout(timer)

                let result = undefined

                if (immediate && !isInvoke) {
                    result = fn.apply(this, args)
                    resolve(result)
                    isInvoke = true
                    return
                }

                timer = setTimeout(() => {
                    result = fn.apply(this, args)
                    resolve(result)
                    timer = null
                    isInvoke = false
                }, delay)
            } catch (error) {
                reject(error)
            }
        })
    }

    _debounce.cancel = function() {
        if (timer) clearTimeout(timer)
        timer = null
        isInvoke = false
    }

    return _debounce
}

/* 节流 */
export function throttle(
    fn,
    interval, { leading = true, trailing = false } = {}
) {
    let startTime = 0
    let timer = null

    const _throttle = function(...args) {
        const nowTime = new Date().getTime()

        /* 第一次不立即执行 */
        if (!leading && startTime === 0) {
            startTime = nowTime
        }

        const waitTime = interval - (nowTime - startTime)

        if (waitTime <= 0) {
            if (timer) clearTimeout(timer)
            fn.apply(this, args)
            startTime = nowTime
            timer = null
            return
        }

        if (trailing && !timer) {
            timer = setTimeout(() => {
                fn.apply(this, args)
                startTime = new Date().getTime()
                timer = null
            }, waitTime)
        }
    }

    _throttle.cancel = function() {
        if (timer) clearTimeout(timer)
        startTime = 0
        timer = null
    }
    return _throttle
}

/* 时间戳 to xxx ago */
export function convertTimestamp(timestamp) {
    if (timestamp !== 0) {
        return dayjs().to(dayjs.unix(timestamp).format('YYYY-MM-DD HH:mm:ss'))
    }
}
export const formatMoney = (money, symbol = "", decimals = 2) => {
    if (!(money && money > 0)) {
      return 0.0;
    }
  
    let arr = money.toFixed(decimals).toString().split(".");
    let first = parseInt(arr[0]).toLocaleString();
    let result = [first, arr[1]].join(".");
    return `${symbol} ${money.toFixed(decimals)}`;
  };
  

/* 转换接口值 */
export function valueConversion(currentValue, newValues) {
    return newValues[+currentValue]
}

/*  格式化 yyyy-mm-dd 为 mm/dd */
export function formateMonDay(data) {
    return dayjs(data).format('M/D')
}

/* 计算截止至当前时间的前七天 */
export function getLastSevenDays() {
    const result = []
    const today = new Date()

    for (let i = 1; i <= 7; i++) {
        const date = new Date(today)
        date.setDate(today.getDate() - i) // 设置为今天的前i天
        const formattedDate = `${date.getMonth() + 1}/${date.getDate()}`
        result.push(formattedDate)
    }

    return result.reverse()
}